import React, { createContext, useContext, useState } from "react";

interface ILogoutConfirmContext {
  isLogoutConfirmOpen: boolean;
  openLogoutConfirm: () => void;
  closeLogoutConfirm: () => void;
}

const LogoutConfirmContext = createContext<ILogoutConfirmContext | undefined>(
  undefined
);

export const LogoutConfirmProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isLogoutConfirmOpen, setIsLogoutConfirmOpen] = useState(false);

  const value = {
    isLogoutConfirmOpen,
    openLogoutConfirm: () => setIsLogoutConfirmOpen(true),
    closeLogoutConfirm: () => setIsLogoutConfirmOpen(false),
  };

  return (
    <LogoutConfirmContext.Provider value={value}>
      {children}
    </LogoutConfirmContext.Provider>
  );
};

export const useLogoutConfirm = (): ILogoutConfirmContext => {
  const context = useContext(LogoutConfirmContext);
  if (!context) {
    throw new Error(
      "useLogoutConfirm must be used within LogoutConfirmProvider"
    );
  }
  return context;
};
